import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';

import * as Actions from './actions';
import * as Api from './api';

const create = action$ =>
    action$
        .ofType(Actions.create.type)
        .map(action => action.payload)
        .mergeMap(({institutionId, childId, billPayerId, deposit}) =>
            Api.create(institutionId, childId, billPayerId, deposit)
                .map(Actions.createSuccess.action)
                .catch(e => Observable.of(Actions.createFailed.action(e))),
        );

const deleteDeposit = action$ =>
    action$
        .ofType(Actions.deleteDeposit.type)
        .map(action => action.payload)
        .mergeMap(({institutionId, childId, deposit}) =>
            Api.deleteDeposit(institutionId, childId, deposit)
                .map(Actions.deleteDepositSuccess.action)
                .catch(e => Observable.of(Actions.deleteDepositFailed.action(e))),
        );

const returnDeposit = action$ =>
    action$
        .ofType(Actions.returnDeposit.type)
        .map(action => action.payload)
        .mergeMap(({institutionId, childId, deposit}) =>
            Api.returnDeposit(institutionId, childId, deposit)
                .map(Actions.returnDepositSuccess.action)
                .catch(e => Observable.of(Actions.returnDepositFailed.action(e))),
        );

const deleteDepositReturn = action$ =>
    action$
        .ofType(Actions.deleteDepositReturn.type)
        .map(action => action.payload)
        .mergeMap(({institutionId, childId, deposit}) =>
            Api.deleteDepositReturn(institutionId, childId, deposit)
                .map(Actions.deleteDepositReturnSuccess.action)
                .catch(e => Observable.of(Actions.deleteDepositReturnFailed.action(e))),
        );

export default combineEpics(create, deleteDeposit, returnDeposit, deleteDepositReturn);
